import { render, staticRenderFns } from "./downDeail.vue?vue&type=template&id=c46a2578&scoped=true&"
import script from "./downDeail.vue?vue&type=script&lang=js&"
export * from "./downDeail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46a2578",
  null
  
)

export default component.exports